var _g, _defs;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgEntitiesV2(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 24 25",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_138_11338)"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M15.5 15.4318L12.5 17.1638C12.1906 17.3425 11.8094 17.3425 11.5 17.1638L8.5 15.4318C8.19061 15.2532 8.00001 14.9231 8 14.5658V11.0298C8.00001 10.6726 8.19061 10.3425 8.5 10.1638L11.5 8.43183C11.8094 8.25319 12.1906 8.25319 12.5 8.43183L15.5 10.1638C15.8094 10.3425 16 10.6726 16 11.0298V14.5658C16 14.9231 15.8094 15.2532 15.5 15.4318Z",
    stroke: "#FF7C33",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M19.389 18.3585L13.0557 22.015C12.4025 22.3921 11.5977 22.3921 10.9446 22.015L4.61122 18.3585C3.95804 17.9814 3.55566 17.2844 3.55566 16.5302V9.06548C3.55566 8.31126 3.95804 7.61432 4.61122 7.23721L10.9446 3.58068C11.5977 3.20357 12.4025 3.20357 13.0557 3.58068L19.389 7.23721C20.0422 7.61432 20.4445 8.31126 20.4445 9.06548V16.5302C20.4445 17.2844 20.0422 17.9814 19.389 18.3585V18.3585Z",
    stroke: "#FF7C33",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M20.1615 17.5862L18.0137 16.3262",
    stroke: "#FF7C33",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M3.83789 8.00977L5.98572 9.26978",
    stroke: "#FF7C33",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M3.83789 17.5862L5.98572 16.3262",
    stroke: "#FF7C33",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M20.1615 8.00977L18.0137 9.26978",
    stroke: "#FF7C33",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M12 19.7979V22.2979",
    stroke: "#FF7C33",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M12 5.79785V3.29785",
    stroke: "#FF7C33",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M15.8658 10.5298L12.4998 12.4732C12.1904 12.6518 11.8092 12.6518 11.4998 12.4732L8.13379 10.5298",
    stroke: "#FF7C33",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M12 17.2979V12.6064",
    stroke: "#FF7C33",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_138_11338"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 24,
    height: 24,
    fill: "white",
    transform: "translate(0 0.797852)"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgEntitiesV2);
export default __webpack_public_path__ + "static/media/EntitiesV2.64d8210897652605b01cad1d46a062e2.svg";
export { ForwardRef as ReactComponent };